module.exports = __webpack_public_path__ + "img/managers.ee81173b.svg";